import React from 'react';

interface FontControlsProps {
  fontFamily: string;
  onFontFamilyChange: (font: string) => void;
  fontSize: number;
  onFontSizeChange: (size: number) => void;
}

const fontOptions = [
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Inconsolata',
  'sans-serif',
  'serif',
  'monospace',
];

const sizeOptions = [
  8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 30, 36, 48, 60, 72, 96, 120, 144
];

const FontControls: React.FC<FontControlsProps> = ({
  fontFamily,
  onFontFamilyChange,
  fontSize,
  onFontSizeChange,
}) => {
  return (
    <div className="flex items-center gap-4 p-2 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 allow-focus">
      <div className="flex items-center gap-2">
        <label htmlFor="font-family" className="text-sm font-medium text-black dark:text-white">Font</label>
        <select
          id="font-family"
          value={fontFamily}
          onChange={(e) => onFontFamilyChange(e.target.value)}
          className="p-1 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary"
          style={{ fontFamily: fontFamily }}
        >
          {fontOptions.map(font => (
            <option key={font} value={font} style={{ fontFamily: font }}>{font}</option>
          ))}
        </select>
      </div>
      <div className="flex items-center gap-2">
        <label htmlFor="font-size" className="text-sm font-medium text-black dark:text-white">Size</label>
        <select
          id="font-size"
          value={fontSize}
          onChange={(e) => onFontSizeChange(Number(e.target.value))}
          className="p-1 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary"
        >
          {sizeOptions.map(size => (
            <option key={size} value={size}>{size}px</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FontControls; 